export default __webpack_public_path__ + "static/media/schoollogo.40f3b4d9.svg";